// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3M6O0","checkboxCol":"Table_checkboxCol__3B5dX","emailCol":"Table_emailCol__2k89I","actionCol":"Table_actionCol__10cY3"};